/**
 * PC 端底部按钮
 */
/* eslint-disable react/require-default-props */
import React from 'react';
import { useIntl } from 'umi';
import { Button } from 'antd';
import { StepType } from '@/utils/FosterServiceConf';
import './FooterButton.less';
import useModalMethod from '../Modal/useModalMethod';

export interface IFooterButton {
  className?: string;
  step?: number;
  stepType?: string;
  handleNextStep?: () => void;
  handlePrevStep?: () => void;
  handleComplete?: () => void;
}

const FooterButton = (props: IFooterButton) => {
  const intl = useIntl();
  const { handlePrevStep, handleNextStep, className = '', step, stepType, handleComplete } = props;
  const [Modal] = useModalMethod();

  const notShowPrevStep = !(step === 1);
  const isDatacheckStep = stepType === StepType.dataCheck;
  const nextStepName = isDatacheckStep ? '身份識別' : '下一步';

  const handleClose = () => {
    handleComplete ? window.top.close() : Modal.quitConfirm();
  };

  return (
    <div className={className}>
      {!handleComplete ? (
        <>
          <Button type="default" onClick={handleClose}>
            {intl.formatMessage({ id: '关闭' })}
          </Button>
          {notShowPrevStep && (
            <Button onClick={handlePrevStep} type="primary">
              {intl.formatMessage({ id: '上一步' })}
            </Button>
          )}
          <Button onClick={handleNextStep} type="primary">
            {intl.formatMessage({ id: nextStepName })}
          </Button>
        </>
      ) : (
        <Button onClick={handleComplete} type="primary">
          {intl.formatMessage({ id: '完成' })}
        </Button>
      )}
    </div>
  );
};

export default FooterButton;
